import { useContext } from 'react'
import { object } from 'prop-types'

import styled from 'styled-components'
import {
  Typography,
  Tooltip,
  Divider,
  Box,
  ChevronLink,
  StackWrap
} from '@telus-uds/components-web'
import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'

const StyledContainer = styled(Box)`
  border: 1px solid red;
  margin-left: 20px;
`

const FinancedDetailsFooter = ({ financeDetails }) => {
  if (!financeDetails) return null

  const { lang } = useContext(localeContext)
  const translate = useTranslate()

  const { balanceAmount, maxAmount } = financeDetails || {}

  const remainingFinancingBalanceText = translate('accessoryFinancing.financeDetailsNote', {
    replacements: {
      BALANCE_AMOUNT: balanceAmount,
      MAX_AMOUNT: maxAmount
    }
  })

  return (
    <>
      <Box vertical={3}>
        <Divider variant={{ decorative: true }} />
      </Box>
      <StyledContainer aria-label="Finance Details" justifyContent="space-between">
        <StackWrap marginBottom={2}>
          <Typography variant={{ size: 'medium' }} dataSet={{ 'di-mask': 'true' }}>
            {remainingFinancingBalanceText}
          </Typography>
          <Tooltip
            content={translate('accessoryFinancing.financeDetailsTooltip')}
            placement="left"
          />
        </StackWrap>
        <ChevronLink
          direction="left"
          href={`/${lang}/mobility/accessories?linkname=Accessories&linktype=ge-meganav`}
        >
          <Typography variant={{ size: 'medium' }}>
            {translate('accessoryFinancing.financeDetailsLink')}
          </Typography>
        </ChevronLink>
      </StyledContainer>
    </>
  )
}

export default FinancedDetailsFooter

FinancedDetailsFooter.propTypes = {
  financeDetails: object
}

FinancedDetailsFooter.defaultProps = {
  financeDetails: null
}
